class CountriesBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.container = block.querySelector('.countries__container');
    this.countries = [...this.container.querySelectorAll('.countries__item--country')];

    if (this.block.dataset.geolocation === 'on') {
      this.getMyCountry();
    }
  }

  getMyCountry() {
    fetch(`${ajaxurl}?action=get_my_country`)
      .then((response) => response.json())
      .then((data) => {
        if (data.data) {
          const replaceIndex = this.countries.findIndex((country) => country.dataset.name === data.data.title);
          const replace = this.countries[replaceIndex > -1 ? replaceIndex : this.countries.length - 1];
          const name = replace.querySelector('.countries__name');
          const contour = replace.querySelector('.countries__contour');

          name.textContent = data.data.title;
          contour.setAttribute('src', data.data.contour);
          replace.href = data.data.link;

          this.container.insertBefore(replace, this.countries[0]);
          this.container.offsetWidth;
          this.container.scrollTo(0, 0);
        }
      });
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.countries').forEach((block) => {
  new CountriesBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=countries', ($block, attributes) => {
    new CountriesBlock($block.find('.countries').get(0), attributes);
  });
}